import { Injectable, OnInit, OnDestroy } from '@angular/core';
import { UtilArray, UtilSequenceProcess } from '@formbird/shared';
import { DocumentSaveService } from './document-save.service';
import { UnsavedDocumentService } from './unsaved-document.service';
import { ModifiedFieldService } from './modified-field.service';
import { ValidationService } from '../validation/validation.service';
import { ClientConstants } from '../../constants/ClientConstants';

const logger = console;

@Injectable({
  providedIn: 'root'
})
export class ChildDocumentListService implements OnInit, OnDestroy {

  /*
   childDocumentInfo = {
    'documentListId': {
      hierarchyDocInfo: {
        parentDocumentId: 'parentDocumentId',
        childDocumentId: 'childDocumentId',
        documentId: 'documentId'
      }
    }
  };*/
  childDocumentInfo = {} as any;

  constructor(
    private documentSaveService: DocumentSaveService,
    private unsavedDocumentService: UnsavedDocumentService,
    private modifiedFieldService: ModifiedFieldService,
    private validationService: ValidationService
  ) {
  }

  ngOnInit() {
    // this.sub = this.currentDocumentService.documentData$.subscribe(documentData => {
    //   this.documentData = documentData;
    // });
  }

  ngOnDestroy() {
    // this.sub.unsubscribe();
  }

  /**
   * setup the document list id
   */
  setupChildDocumentListId() {
    const documentListId =
      this.unsavedDocumentService.createUnsavedDocumentList(ClientConstants.CHILD_DOCUMENT_INFO_LIST);

    this.childDocumentInfo[documentListId] = {
      documentListId: documentListId,
      hierarchyDocInfo: {
        parentDocumentId: null,
        childDocumentId: null,
        documentId: null
      }
    };

    logger.info('Setup child document list id...' + documentListId);

    return this.childDocumentInfo[documentListId];
  }

  /**
   * perform save of the all child document list
   */
  save() {

    logger.info('Saving child documents...');

    const _self = this;

    return new Promise((resolve) => {
      // wait for onFieldChange to finish before saving
      _self.validationService.waitPendingEvents(function () {
        const saveChildPromise = _self.saveChildDocumentList();
        resolve(saveChildPromise);
      });
    });
  }

  saveChildDocumentList() {

    const _self = this;

    const documentListIds = Object.keys(_self.childDocumentInfo);
    const unsavedDocumentListIds = _self.modifiedFieldService.getAllChangedDocumentListIds();

    // save documents sequentially so that all document saves aren't sent to the server at the
    // same time. See the notes of Mantis 11213 for further details
    function asyncJob(documentListId) {
      if (documentListId) {

        if (UtilArray.contains(unsavedDocumentListIds, documentListId)) {
          return _self.documentSaveService.save(documentListId);
        }

      }
    }

    return UtilSequenceProcess.processList(documentListIds, asyncJob);
  }

  getChildDocumentInfo(childDocumentListId) {
    return this.childDocumentInfo[childDocumentListId];
  }

  resetChildDocumentListId() {
    this.childDocumentInfo.documentListId = null;
    this.childDocumentInfo.hierarchyDocInfo = [];
    logger.info('Child Document Info has been reset.');
  }

  removeChildDocumentInfo(childDocumentListId) {
    if (childDocumentListId) {
      delete this.childDocumentInfo[childDocumentListId];
    }
  }

  clearDocuments(childDocumentListId) {

    const _self = this;

    if (childDocumentListId) {

      const unsavedDocuments = _self.unsavedDocumentService.getUnsavedDocuments(childDocumentListId);

      if (unsavedDocuments) {
        const docIds = Object.keys(unsavedDocuments);

        docIds.forEach(function (docId) {
          const unsavedDoc = unsavedDocuments[docId];
          _self.modifiedFieldService.removeModifiedDocumentFields(unsavedDoc.documentId);
        });
      }

      _self.unsavedDocumentService.removeDocumentList(childDocumentListId);
      _self.removeChildDocumentInfo(childDocumentListId);
    }
  }

}
